program SITE2;

uses
  Vcl.Forms,
  WEBLib.Forms,
  Unit1 in 'Unit1.pas'{*.html};

{$R *.res}

begin
  Application.Initialize;
  Application.MainFormOnTaskbar := True;
  Application.CreateFormDirect(TForm1, Form1);
  Application.Run;
end.
